<template>
  <div class="cartItem cart-list-item"
    :class="{
      disabled: !item.isAvailable || !item.isOpen || !isPayAvailable || item.removed || item.isDisabled,
      changed: change && item.changedInfo,
      hiddenPrice: hiddenPrice
      }">
    <p v-if="item.first" class="submitTo notranslate">{{submitTo(item.submitId)}}</p>
    <button type="button"
      class="btnDel toCapitalize"
      :style="isFloating && {...skinStyle('defaultBtnBg', 'border-color'), ...skinStyle('defaultBtnBg', 'color')}"
      @click="deleteItem">
      {{ locale.delete }}
    </button>
    <div class="checkbox">
      <input type="checkbox"
        :id="item.cartId"
        :disabled="!item.isAvailable || !item.isOpen || item.removed || item.isDisabled"
        v-model="item.isChecked"
        @change="checkedItem">
      <label :for="item.cartId"></label>
    </div>
    <div class="inner">
      <p v-if="item.removed" class="validateMessage notranslate">{{locale.page_removed}}</p>
      <p v-if="!item.isAvailable" class="validateMessage notranslate" @click.stop="toggleTable(true)">{{locale.not_available}}<i>{{locale.available_time}}</i></p>
      <p v-if="!item.isOpen || item.isDisabled" class="validateMessage notranslate">{{locale.state_unavailable}}</p>
      <!-- state: 01 -->
      <router-link
        v-if="item.isOpen && item.isAvailable && (itemInfo.isPage || itemInfo.isProduct)"
        :to="{
          name: itemInfo.routeName,
          params: {
            ...itemInfo.routeParams,
            lang: lang
          }
        }"
        class="itemInfo" :class="{isEmpty: isEmpty(item.info.subject[lang])}">
        <div v-if="item.info.thumbnail && item.info.thumbnail !== ''" class="thumb">
          <img :src="item.info.thumbnail" alt="">
        </div>
        <div class="subject">
          {{item.info.subject[lang]}}
          <p v-if="item.place" class="place">(<span class="notranslate">{{locale.place}}</span>: {{item.place[lang]}})</p>
        </div>
      </router-link>
      <!-- //state: 01 -->
      <!-- state: 02 -->
      <div v-else class="itemInfo" :class="{isEmpty: isEmpty(item.info.subject[lang])}">
        <div v-if="item.info.thumbnail && item.info.thumbnail !== ''" class="thumb">
          <img :src="item.info.thumbnail" alt="">
        </div>
        <p class="subject">
          {{item.info.subject[lang]}}
          <span v-if="item.place" class="place">(<span class="notranslate">{{locale.place}}</span>: {{item.place[lang]}})</span>
        </p>
      </div>
      <!-- //state: 02 -->
      <div class="itemOption">
        <!-- options -->
        <div v-if="(options && options.length > 0) || item.datetime" class="optionInfo">
          <div class="list">
            <div v-for="(order, index) in options.filter(x => x.value)"
              :key="index"
              :class="{isSubOption: order.isSubOption}">
              <div v-if="order.type === 'checkbox'" class="row" :style="{marginLeft: `${order.isSubOption && (order.optionDepth - 1) * 10}px`}">
                <span class="label">{{order.label[lang]}}</span>
                <div class="value">
                  <span
                    v-for="(option, index) in displayValue(order)"
                    :key="index"
                    class="valueArr">
                    {{option}}
                  </span>
                </div>
              </div>
              <div v-else-if="order.type === 'uploadImage'" class="row">
                <span class="label">{{order.label[lang]}}</span>
                <div class="value notranslate">
                  <div class="valueOption"
                    v-for="(option, index) in order.value"
                    :key="index">
                    <span v-if="option.previewType === 'filename'">🖺 {{option.name}}</span>
                    <img v-else :src="option.path" class="mt5" alt="">
                  </div>
                </div>
              </div>
              <div v-else class="row" :style="{marginLeft: `${order.isSubOption && (order.optionDepth - 1) * 10}px`}">
                <span class="label">{{order.label[lang]}}</span>
                <div class="value"
                  :class="{notranslate: order.type === 'rate'}">
                  <img v-if="order.type === 'signaturepad'" :src="order.value" alt="">
                  <span v-else>{{displayValue(order)}}</span>
                </div>
              </div>
            </div>
            <!-- datetime -->
            <div v-if="item.datetime" class="row notranslate">
              <span class="label">{{locale.datetime}}</span>
              <span class="value">{{requestTime}}</span>
            </div>
            <!-- //datetime -->
          </div>
        </div>
        <!-- //options -->
        <!-- coupon -->
        <div v-if="item.useCoupon" class="optionInfo">
          <div class="list">
            <div v-for="(coupon, index) in item.useCoupon"
              :key="index"
              class="item">
              <div>
                <span class="label">({{locale.coupon}}) {{coupon.payload.text1[lang] || coupon.payload.text2[lang] || coupon.title}}</span>
                <div class="value notranslate">
                  {{getCouponValue(coupon.payload)}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //coupon -->
        <!-- price -->
        <div class="priceInfo toCapitalize">
          <div class="byQuantity row notranslate">
            <div v-if="(itemInfo.isProduct && !itemInfo.isPage) || ((item.price.info && item.price.info.price && item.price.info.price > 0) && (itemInfo.isPage && item.content && item.content.find(x => x.type === 'quantity')))" class="item priceDpBoard optionGroup">
              <span class="label">{{locale.summary_unitprice}}</span>
              <span class="value">{{priceFormat(item.guestTypePrice ? item.guestTypePrice.normalPrice : item.price.info.price)}}</span>
            </div>
            <div v-if="priceOption.length" class="priceDpBoard optionGroup">
              <div class="item"
                v-for="(info, index) in priceOption"
                :key="index">
                <div class="label"><span class="notranslate">[{{locale.option_price}}]</span> {{info.label}} <span v-if="info.quantity">({{info.quantity}})</span></div>
                <div class="value notranslate">{{priceFormat(info.price)}}</div>
              </div>
            </div>
            <div v-if="item.quantity" class="item itemQuantity" :class="{changeValue: item.changedInfo, productQuantity: isProduct}">
              <span class="label">{{locale.quantity}}</span>
              <span class="value">
                <button v-if="isProduct" class="btnMinus" type="button" :class="{isLimit: limitQuantity('minus')}" :disabled="disabledQuantity" @click.stop="setProductQuantity('minus')">-</button>
                <em>{{item.price.info.quantity > 0 ? item.price.info.quantity : locale.out_of_stock}}</em>
                <em v-if="item.changedInfo">{{item.changedInfo.qty > 0 ? item.changedInfo.qty : locale.out_of_stock}}</em>
                <button v-if="isProduct" class="btnPlus" type="button" :class="{isLimit: limitQuantity('plus')}" :disabled="disabledQuantity" @click.stop="setProductQuantity('plus')">+</button>
              </span>
            </div>
            <!-- 고객식별타입 -->
            <div v-if="item.guestTypePrice && isGuestDiscount" class="item priceDpBoard">
              <span class="label">{{item.guestTypePrice.name[lang]}}</span>
              <span class="value">{{item.guestTypePrice.priceDiscount}}</span>
            </div>
            <!-- //고객식별타입 -->
            <!-- discount -->
            <div v-if="item.price.info && item.price.info.discount" class="item priceDpBoard">
              <span class="label">{{locale.discount}}</span>
              <span class="value">-{{priceFormat(item.price.info.discount)}}</span>
            </div>
            <!-- //discount -->
            <div v-if="!item.price.info.noPrice && (item.price.info && item.price.info.total >= 0 || item.changedInfo && item.changedInfo.total >= 0)"
                class="item price priceDpBoard"
                :class="{changeValue: item.changedInfo}">
              <div class="label">{{locale.total}}</div>
              <div class="value">
                <span v-if="item.guestTypePrice && item.guestTypePrice.normalPrice" class="normalPrice">
                  {{priceFormat(item.guestTypePrice.normalPrice * item.guestTypePrice.quantity)}}
                </span>
                <em>{{priceFormat(itemTotalPrice)}}</em>
                <em v-if="item.changedInfo">{{item.changedInfo.total > 0 ? priceFormat(item.changedInfo.total) : locale.out_of_stock}}</em>
              </div>
            </div>
          </div>
        </div>
        <!-- //price -->
        <!-- <div class="btns">
          <button type="button" class="btn sizeS toCapitalize" :disabled="!item.isAvailable || !item.isOpen" @click="requestItem">{{locale.btn_request}}</button>
          <button type="button" class="btn sizeS btnPrimary toCapitalize">{{locale.btn_payment}}</button>
          <button type="button" class="btn sizeS btnWhite toCapitalize" @click="deleteItem">{{locale.btn_delete}}</button>
        </div> -->
      </div>
      <div v-if="item.last" class="multiCartItem toCapitalize">
        <div v-if="item.multiCartPrice" class="priceDpBoard">
          <div v-if="multiCartTax">
            <div class="total tax">
              <span class="label">{{locale.subtotal}}</span>
              <span class="value">
                <em>{{priceFormat(multiCartTax.subtotal)}}</em>
              </span>
            </div>
            <div class="total tax">
              <span class="label">{{locale.tax}}({{multiCartTax.taxLabel}})</span>
              <span class="value">
                <em>{{priceFormat(multiCartTax.tax)}}</em>
              </span>
            </div>
            <div class="total">
              <span class="label">{{locale.total}}</span>
              <span class="value">
                <em>{{priceFormat(multiCartTax.total)}}</em>
              </span>
            </div>
          </div>
          <div v-else class="total">
            <span class="label">{{locale.total}}</span>
            <span class="value">
              <em>{{priceFormat(item.multiCartPrice)}}</em>
            </span>
          </div>
        </div>
        <div class="btns">
          <button type="button" class="btn toCapitalize" 
            :disabled="!multiCartAvailable" 
            :style="multiCartAvailable && {
              ...skinStyle('productBtncart', 'background-color'),
              ...skinStyle('productBtncart', 'border-color'),
            }"
            @click="requestMultiCart">
            <span>{{priceFormat(item.multiCartPrice)}} / </span>
            {{locale.btn_request}}
          </button>
        </div>
      </div>
    </div>
    <AvailableTable
      v-if="!isAvailable && availableTable"
      :table="item.info.available.set"
      :locale="locale"
      @close="toggleTable(false)" />
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import { DateTime } from 'luxon'
import moment from 'moment/moment'
import AvailableTable from '@/components/Util/AvailableTable'
import { mapGetters } from 'vuex'
export default {
  name: 'CartItem',
  props: [
    'lang',
    'item',
    'change',
    'locale',
    'multiCartAvailable',
    'multiCartTax',
    'submitCode',
    'isFloating'
  ],
  components: {
    AvailableTable
  },
  computed: {
    ...mapGetters({
      pointColors: 'common/getPointColors',
    }),
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    options () {
      return this.item.content || []
      /*
      return this.item.content.filter(x => {
        return x.value &&
        x.type === 'checkbox'
          ? x.value.filter(v => regExp.replaceAllEmpty(v)).length
          : regExp.replaceAllEmpty(x.value).length
      })
      */
    },
    getAvailableDay () {
      return this.$store.getters['util/getAvailableDay']
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    priceOption () {
      const lang = this.lang
      let option = []
      this.item.content.forEach(function (x) {
        if (x.value) {
          if (x.type === 'checkbox') {
            option = option.concat(x.value.filter(o => o.price && o.price.length).map(function (oo) {
              return {
                label: oo.label[lang],
                price: oo.quantity ? oo.price * oo.quantity : oo.price,
                ...oo.quantity && {
                  quantity: oo.quantity
                }
              }
            }))
          } else if (x.value.price) {
            option = option.concat({
              label: x.value.label[lang],
              price: x.value.quantity ? x.value.price * x.value.quantity : x.value.price,
              ...x.value.quantity && {
                quantity: x.value.quantity
              }
            })
          }
        }
      })
      return option
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    },
    requestTime () {
      const settime = this.item.datetime ? DateTime.fromISO(this.item.datetime.value.settime, { zone: this.timezone }) : null
      const requestTime = this.item.datetime
        ? this.item.datetime.value.type === 'asap' ? this.locale.datetime_asap : settime.toFormat(this.format)
        : null
      return requestTime
    },
    itemInfo () {
      const isPage = !!this.item.pageId && this.item.pageId !== null
      const isProduct = !!this.item.productId && this.item.productId !== null
      return {
        isPage: isPage,
        isProduct: isProduct,
        routeName: isPage ? 'page' : isProduct ? 'product' : null,
        routeParams: {
          ...isPage && {
            id: this.item.pageId
          },
          ...isProduct && {
            productId: this.item.productId
          }
        }
      }
    },
    isPayAvailable () {
      const price = this.item.price.info
      const changedPrice = this.item.changedInfo
      return this.item.manage ? changedPrice ? changedPrice.qty > 0 && changedPrice.total > 0 : price.quantity > 0 && price.total > 0 : true
    },
    isGuestDiscount () {
      return this.item.guestTypePrice && this.item.guestTypePrice.normalPrice !== this.item.guestTypePrice.total
    },
    itemTotalPrice () {
      return this.item.price
        ? this.item.price.info.tax ? this.item.price.info.subtotal : this.item.price.info.total
        : 0
    },
    hiddenPrice () {
      return this.item.hiddenPrice
    },
    isProduct () {
      return this.item.productId && this.item.productItemId && !this.item.pageId
    },
    disabledQuantity () {
      const removed = this.item.removed
      const notAvailable = !this.item.isAvailable
      const disabled = !this.item.isOpen || this.item.isDisabled
      const disabledCase = removed || notAvailable || disabled
      return this.isProduct && disabledCase
    },
    defaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    }
  },
  created () {
    if (this.item) {
      this.isAvailable = this.item.isAvailable
    }
  },
  data () {
    return {
      itemAvailable: {},
      isAvailable: true,
      availableTable: false,
      disabledMinus: false,
      disabledPlus: false
    }
  },
  methods: {
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    checkAvailableTime () {
      let isAvailable = true
      const available = this.item.info.available // submit 데이터
      const isAlways = available.state === '01' // 01 ? always : each
      const today = moment().isoWeekday() - 1
      const day = available.set[today]
      const check = this.getAvailableDay(day)
      this.checkAvailable = setInterval(() => {
        isAvailable = isAlways
          ? true
          : check
        this.isAvailable = isAvailable
      }, 1000)
    },
    toggleTable (isOpen) {
      this.availableTable = isOpen
    },
    displayValue (order) {
      const lang = this.lang
      let value = order.value
      switch (order.type) {
        case 'rate':
          value = `${value.value} / ${value.max}`
          break
        case 'radio':
          value = value.label[lang] + (value.quantity ? ` (${value.quantity})` : '')
          break
        case 'checkbox':
          value = value.map(x => {
            const label = x.label[lang]
            const quantity = x.quantity ? `(${x.quantity})` : ''
            return `${label} ${quantity}`
          })
          break
        case 'select':
          value = value.label[lang]
          break
        case 'calendar':
          value = DateTime.fromISO(value).toFormat(this.dateFormat)
          break
      }
      return value
    },
    getCouponValue (coupon) {
      let result = ''
      function discountRate (total, rate) { // 할인율 적용된 금액
        const totalPrice = total && parseFloat(total) > 0
        return totalPrice ? parseFloat(total) * parseFloat(rate) / 100 : null
      }
      if (coupon && coupon.discount) {
        const discountType = coupon.discountType
        const value = coupon.discountValue
        const total = this.item.couponPrice.normalPrice
        switch (discountType) {
          case 'price':
            result = this.priceFormat(value)
            break
          case 'rate':
            result = discountRate(total, value)
              ? `${this.priceFormat(discountRate(total, value))}` // ${value}%
              : ''
            break
        }
        result = `-${result}`
      }
      return result
    },
    displayPrice (price) {
      const currency = this.$store.state.common.setting.currencyEntity
      return `${currency} ${regExp.comma(price)}`
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    requestMultiCart () {
      this.$emit('requestMultiCart', this.item.submitId)
    },
    checkedItem (e) {
      const isChecked = e.target.checked
      this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: isChecked })
    },
    deleteItem (e) {
      let id = []
      e.stopPropagation()
      id.push(this.item.cartId)
      this.$emit('delete', id)
    },
    isEmpty (str) {
      return str && regExp.replaceAllEmpty(str).length <= 0
    },
    submitTo (submitId) {
      const code = this.submitCode.find(x => x.id === submitId)
      return code ? code.label : null
    },
    limitQuantity (plusMinus) {
      const quantity = this.item.quantity && this.item.quantity.value && this.item.quantity.value.quantity
      const min = this.item.info.min
      const max = this.item.info.max
      const plus = plusMinus === 'plus'
      const minus = plusMinus ==='minus'
      return (plus && quantity === max) || (minus && quantity === min)
    },
    setProductQuantity (plusMinus) {
      let quantity = this.item.quantity && this.item.quantity.value && this.item.quantity.value.quantity
      if (quantity) {
        const min = this.item.info.min
        const max = this.item.info.max
        const plus = plusMinus === 'plus'
        const minus = plusMinus ==='minus'
        if (plus) {
          quantity = quantity + 1 > max ? max : quantity + 1
        } else {
          quantity = quantity - 1 < min ? min : quantity - 1
        }
        this.$store.commit('cart/setItemQuantity', {cartId: this.item.cartId, quantity: quantity})
        this.$emit('setQuantityItem', {cartId: this.item.cartId, quantity: quantity})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.validateMessage {
  display: inline-block;
  position: relative;
  margin-bottom: 8px;
  padding: 5px 8px;
  text-align: center;
  vertical-align: top;
  white-space: nowrap;
  color: $color-white;
  border-radius: 4px;
  background-color: $color-red;
  &:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 28px;
    width: 6px;
    height: 6px;
    margin-top: -3px;
    background-color: $color-red;
    transform: rotate(45deg);
  }
  i {
    display: inline-block;
    position: relative;
    margin-left: 5px;
    padding: 0 4px;
    font-size: 10px;
    font-style: normal;
    color: $color-red;
    border-radius: 4px;
    background-color: $color-white;
  }
}
.valueArr + .valueArr:before {
  content: ", ";
}
.normalPrice {
  margin-right: 10px;
  font-weight: normal;
  font-size: 0.85em;
  text-decoration: line-through;
  color: $color-grey;
}
@media screen and (min-width: 768px) {
  .validateMessage {
    width: calc(100% - 60px);
    margin-left: 30px;
    margin-bottom: 5px;
    border-radius: 20px;
    &:before {
      display: none;
    }
  }
}
</style>
